module.exports = __webpack_public_path__ + "static/partitions-bc2a136d45237b48710a0ef17ce07d80.jpg";